if (!customElements.get('progress-bar')) {
  class ProgressBar extends HTMLElement {
    constructor() {
      super();
      this.value = this.getAttribute('data-value');
      this.total = this.getAttribute('data-total');
      this.bar = this.querySelector('[data-bar]');
      this.progress = this.querySelector('[data-progress]');
      this.message = this.querySelector('[data-message]');
    }

    connectedCallback() {
      // Set initial progress width to prevent flash
      const cappedValue = Math.min(this.value, this.total);
      this.style.setProperty('--progress-width', `${(cappedValue / this.total) * 100}%`);
    }

    setValue(value) {
      this.value = value;
      const cappedValue = Math.min(value, this.total);
      const progressWidth = (cappedValue / this.total) * 100;
      this.style.setProperty('--progress-width', `${progressWidth}%`);
    }

    setMessage(message) {
      this.message.innerText = message;
    }
  }

  customElements.define('progress-bar', ProgressBar);
}

// Progress bar updater for PLP pages (member pricing only)
async function updateProgressBar() {
  const progressBar = document.querySelector('progress-bar');
  if (!progressBar) return;

  try {
    const response = await fetch('/cart.js');
    if (!response.ok) return;
    const cartData = await response.json();

    // Use existing CartCountUpdater to calculate bottles (reuse existing logic)
    if (window.CartCountUpdater) {
      const bottleCount = await window.CartCountUpdater.calculateTotalItemCount(cartData);
      const total = parseInt(progressBar.getAttribute('data-total')) || 6;
      progressBar.setValue(Math.min(bottleCount, total));

      if (total - bottleCount > 0) {
        progressBar.setMessage(`Add ${total - bottleCount} more bottles to unlock member pricing!`);
      } else {
        progressBar.setMessage('Congrats! You unlocked member pricing for this order!');
      }
    }
  } catch (error) {
    console.error('Failed to update progress bar:', error);
  }
}

// Listen for cart updates and update progress bar
document.addEventListener('cart:updated', updateProgressBar);
